<template>
  <v-text-field
    v-disable-number-scroll
    outlined
    dense
    type="number"
    :label="$t('common.answer')"
    :value="response"
    :disabled="loading"
    :rules="rules"
    @input="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: 'NumberForm',

  props: {
    response: {
      required: false,
      default: null,
    },
    loading: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
